import { Components, Theme } from "@mui/material/styles"

export const muiBackdrop = (): Components<
  Omit<Theme, "components">
>["MuiBackdrop"] => {
  return {
    styleOverrides: {
      root: {
        backgroundColor: "rgba(30, 30, 30, 0.55)",
      },
    },
  }
}
